export default __webpack_public_path__ + "static/media/CancelPlan.5bf9a57e.svg";